<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :width="40"
        :title="$t('labels.remoocModule.remoocCategory.detail')"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4">
                <hts-form-select
                    v-model="dataFormEditRemoocCategory.type"
                    v-model:text="dataFormEditRemoocCategory.name"
                    :label="$t('labels.remoocModule.containerCapacity')"
                    readonly
                    :items="towingCapacityList"
                    key-id="value"
                    key-label="label"
                    :color="props.color"
                    name="type"
                    prop="type" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.wheelNumber"
                    :label="$t('labels.vehicleModule.category.wheelNumber')"
                    :color="props.color"
                    readonly
                    type="number"
                    name="vehicleModule.category.wheelNumber"
                    prop="vehicleModule.category.wheelNumber" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.priceTires"
                    :label="$t('labels.vehicleModule.category.priceTires')"
                    :color="props.color"
                    readonly
                    type="number"
                    name="priceTires"
                    prop="priceTires" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.depreciationTires"
                    :label="$t('labels.vehicleModule.category.depreciationTires')"
                    :color="props.color"
                    readonly
                    type="number"
                    name="depreciationTires"
                    prop="depreciationTires" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.depreciationPeriodRemooc"
                    :label="$t('labels.depreciationPeriodRemoocByYear')"
                    :color="props.color"
                    readonly
                    type="number"
                    name="depreciationPeriodRemoocByYear"
                    prop="depreciationPeriodRemoocByYear" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.priceLiquidation"
                    :label="$t('labels.priceLiquidation')"
                    :color="props.color"
                    readonly
                    type="number"
                    name="priceLiquidation"
                    prop="priceLiquidation" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.depreciationRate"
                    :label="$t('labels.depreciationRateAmountYear')"
                    readonly
                    :color="props.color"
                    type="number"
                    name="depreciationRate"
                    prop="depreciationRate" />
                <hts-form-input
                    v-model="dataFormEditRemoocCategory.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    readonly
                    name="description"
                    prop="description" />
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import form, { AxesType, TowingCapacity } from '../imports/remooc'
import { CoveringContainerLevel, GoodsTypes } from '../imports/form'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  infoRemoocCategory: {
    type: Object
  }
})

const emits = defineEmits(['close', 'refreshTables'])

const visible = ref(false)
const creating = ref(false)
const openEditRemoocCategory = () => {
  _init()
  nextTick(() => {
    visible.value = true
  })
}
defineExpose({
  openEditRemoocCategory
})
const closeOverSide = () => {
  visible.value = false
}

const dataFormEditRemoocCategory = reactive({ ...form.initRemoocCategory })
const towingCapacityList = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

watch(props, () => {
  _init()
})

const _init = () => {
  Object.assign(dataFormEditRemoocCategory, { ...props.infoRemoocCategory })
}
const undo = () => {
  dataFormEditRemoocCategory.name = ''
  dataFormEditRemoocCategory.type = undefined
  dataFormEditRemoocCategory.wheelNumber = undefined
  dataFormEditRemoocCategory.priceTires = undefined
  dataFormEditRemoocCategory.depreciationTires = undefined
  dataFormEditRemoocCategory.depreciationPeriodRemooc = null
  dataFormEditRemoocCategory.priceLiquidation = null
  dataFormEditRemoocCategory.depreciationRate = null
  dataFormEditRemoocCategory.description = ''
}
</script>
